// The option key lists the basic_info and education forms render. They live here, rather than as
// angular constants, so React and angular read one copy. careers_module.js registers each list as
// the constant of the same name.
//
// Each key resolves to a label under the `careers.field_options` locale namespace.

export const CAREERS_FULL_TIME_EXPERIENCE_KEYS = ['0_1', '2_6', '7_10', '11_15', '16_plus'];

export const CAREERS_RECENT_ROLE_KEYS = [
    'senior_management_role',
    'management_role',
    'professional_role',
    'service_role',
    'retail_role',
];

// Some career profiles still hold one of these two roles. The dropdown adds the stored value back
// when it is one of them, so an admin does not see an empty select. See https://trello.com/c/J5h4xBE8
export const CAREERS_LEGACY_RECENT_ROLE_KEYS = ['administrative_role', 'skilled_labor_role'];

export const CAREERS_HIGHEST_EDUCATION_KEYS = [
    'doctorate',
    'masters',
    'undergraduate_bachelor',
    'associates',
    'high_school',
];
